export const DOCUMENT_KEY = 'document';
